import { FileUpload } from "primereact/fileupload";
import { Divider } from "primereact/divider";
import { TechLogo } from "../../images/Careers";

import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { useRef, useState } from "react";

function Form({ onFiles }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [numberOfDays, setNumberOfDays] = useState("");
  const [expectedCTC, setExpectedCTC] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const inputRef = useRef(null);

  const openFileDialog = () => {
    inputRef.current?.click();
  };

  const handleChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (onFiles) onFiles(files);
    e.target.value = null;
  };

  return (
    <div className="max-w-6.5xl mx-auto">
      <h2 className="text-3xl font-extrabold text-[#434253] mb-6">
        Autofill Application
      </h2>
      <p className="text-[#0F172A] mb-4">
        Upload your resume or CV in seconds using the autofill option.
      </p>

      <div className="flex items-center">
        <div
          className="w-full md:w-2/3 relative border border-dashed border-[#CBD5E1] rounded-lg bg-[#F5F6FA] transition p-12 text-center cursor-pointer"
          onClick={openFileDialog}
        >
          <input
            ref={inputRef}
            type="file"
            name="resume"
            accept=".doc,.docx,.pdf,.odt,.rtf"
            onChange={handleChange}
            className="hidden"
          />

          <p className="text-[#475569] text-base font-400 leading-relaxed">
            <span className="text-[#F42F39] font-semibold">
              Upload your resume
            </span>{" "}
            or drag and drop it here
          </p>
          <p className="text-sm text-[#6B7280] mt-2">
            Only .doc, .docx, .pdf, .odt, .rtf (Optional)
          </p>
        </div>

        <div className="grid gap-5 w-full md:w-1/3 justify-center">
          <span className="flex items-center rounded-lg border border-[#2863BE]">
            <i className="fab fa-linkedin-in px-4 py-2 text-xl text-[#2863BE]"></i>
            <button className="bg-[#2863BE] text-white w-full px-6 rounded-br-lg rounded-tr-lg h-full font-500">
              Apply with LinkedIn
            </button>
          </span>
        </div>
      </div>

      <Divider />

      <h3 className="text-3xl font-extrabold text-[#434253] mb-6">
        Basic Info
      </h3>
      <div className="grid gap-4">
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            First Name <span className="text-red-500">*</span>
          </label>
          <InputText
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="First Name"
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
          />
        </div>
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            Last Name <span className="text-red-500">*</span>
          </label>
          <InputText
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Last Name"
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
          />
        </div>
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            Email <span className="text-red-500">*</span>
          </label>
          <InputText
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
          />
        </div>
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            Phone <span className="text-red-500">*</span>
          </label>
          <InputText
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone Number"
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
          />
        </div>
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            Do you have experience in AI, Automation, or Cloud Projects?
          </label>
          <div className="flex items-center gap-6 mt-2">
            <div className="flex items-center gap-2">
              <Checkbox
                inputId="yes"
                name="employmentStatus"
                value="Yes"
                onChange={(e) => setSelectedOption(e.value)}
                checked={selectedOption === "Yes"}
              />
              <label htmlFor="yes" className="text-[#334155]">
                Yes
              </label>
            </div>

            <div className="flex items-center gap-2">
              <Checkbox
                inputId="no"
                name="employmentStatus"
                value="No"
                onChange={(e) => setSelectedOption(e.value)}
                checked={selectedOption === "No"}
              />
              <label htmlFor="no" className="text-[#334155]">
                No
              </label>
            </div>
          </div>
        </div>
      </div>

      <Divider />
      <h3 className="text-3xl font-extrabold text-[#434253] mb-6">
        Other Information
      </h3>
      <div className="grid gap-4">
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            Notice Period (Days)
          </label>
          <InputText
            value={numberOfDays}
            onChange={(e) => setNumberOfDays(e.target.value)}
            placeholder="No Of Days"
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
          />
        </div>
        <div>
          <label htmlFor="fullName" className="text-md font-400 text-[#0F172A]">
            Expected CTC
          </label>
          <InputText
            value={expectedCTC}
            onChange={(e) => setExpectedCTC(e.target.value)}
            placeholder="00000"
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
          />
        </div>
      </div>
      <Divider />

      <Divider />
      <div className="w-full gap-6 flex justify-end mb-10">
        <button
          type="submit"
          className=" text-[#F32F39] border-[#F32F39] border text-md px-5 md:px-6 py-2 md:py-3 rounded-md font-medium transition-all flex items-center gap-4"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-activeColor text-white text-md px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
        >
          Submit Application
        </button>
      </div>
    </div>
  );
}

export default Form;
